(function ($, Drupal) {
  Drupal.behaviors.formValidation = {
    attach: function (context, settings) {
      function validateCityField(selector) {
        $(selector).on('input', function () {
          const cityValue = $(this).val().trim();
          console.log(cityValue);

          const cityRegex = /^[a-zA-ZáéíóúÁÉÍÓÚ\s]+$/;

          if (!cityRegex.test(cityValue)) {
            $(this).addClass('is-empty');

            if (!$(this).next('.invalid-feedback').length) {
              $(this).after('<div class="invalid-feedback">Por favor, ingresa un nombre de ciudad válido.</div>');
            }
          } else {
            $(this).removeClass('is-empty');
            $(this).next('.invalid-feedback').remove();
          }
        });
      }

      function validateMail(selector, errorMessage) {
        $(selector).on('input', function () {
          const emailValue = $(this).val().trim();
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          const emptyMessage = 'Campo obligatorio';

          if (emailValue === '') {
            $(this).addClass('is-empty');
            if ($(this).next('.invalid-feedback').length === 0) {
              $(this).after('<div class="invalid-feedback">' + emptyMessage + '</div>');
            } else {
              $(this).next('.invalid-feedback').text(emptyMessage);
            }
          } else {
            $(this).removeClass('is-empty');
            $(this).next('.invalid-feedback').remove();
          }
          if (!emailRegex.test(emailValue)) {
            $(this).addClass('is-empty');
            if (!$(this).next('.invalid-feedback').length) {
              $(this).after('<div class="invalid-feedback">Por favor, ingresa un correo electrónico válido.</div>');
            }
          } else {
            $(this).removeClass('is-empty');
            $(this).next('.invalid-feedback').remove();
          }
        });
      }

      function validateNumericField(selector, errorMessage) {
        $(selector).on('input', function () {
          const value = $(this).val();
          const emptyMessage = 'Campo obligatorio.';
          if (value === '') {
            $(this).addClass('is-empty');
            if ($(this).next('.invalid-feedback').length === 0) {
              $(this).after('<div class="invalid-feedback">' + emptyMessage + '</div>');
            } else {
              $(this).next('.invalid-feedback').text(emptyMessage);
            }
          } else {
            $(this).removeClass('is-empty');
          }
          if (!/^\d+$/.test(value)) {
            $(this).addClass('is-invalid');
            if ($(this).next('.invalid-feedback').length === 0) {
              $(this).after('<div class="invalid-feedback">' + errorMessage + '</div>');
            }
          } else {
            $(this).removeClass('is-invalid');
            $(this).next('.invalid-feedback').remove();
          }
        });
      }

      function validateAlphaField(selector, errorMessage) {
        $(selector).on('input', function () {
          const value = $(this).val();
          const emptyMessage = 'Campo obligatorio.';
          if (value === '') {
            $(this).addClass('is-empty');
            if ($(this).next('.invalid-feedback').length === 0) {
              $(this).after('<div class="invalid-feedback">' + emptyMessage + '</div>');
            } else {
              $(this).next('.invalid-feedback').text(emptyMessage);
            }
          } else {
            $(this).removeClass('is-empty');
          }
          if (!/^[a-zA-ZáéíóúÁÉÍÓÚ\s]+$/.test(value)) {
            $(this).addClass('is-invalid');
            if ($(this).next('.invalid-feedback').length === 0) {
              $(this).after('<div class="invalid-feedback">' + errorMessage + '</div>');
            }
          } else {
            $(this).removeClass('is-invalid');
            $(this).next('.invalid-feedback').remove();
          }
        });
      }

     

      // Aplicar validaciones
      validateNumericField('#edit-document-number', 'Este campo solo acepta valores numéricos.');
      validateNumericField('#edit-phone-number', 'Este campo solo acepta valores numéricos.');
      validateAlphaField('#edit-name', 'Este campo solo acepta caracteres alfabéticos.');
      validateAlphaField('#edit-lastname', 'Este campo solo acepta caracteres alfabéticos.');
      validateMail('#edit-mail', 'Este campo solo acepta caracteres alfabéticos.');
      validateCityField('#edit-city');

     

      // Validación en el botón de enviar
      const submitButton = document.querySelector('#edit-actions-submit');
      const form = document.querySelector('.webform-submission-executive-check-form');

      if (submitButton && form) {
        submitButton.addEventListener('click', function (e) {
          let isValid = true;
          const requiredFields = form.querySelectorAll('input[required], textarea[required], select[required]');
          requiredFields.forEach(function (field) {
            const value = field.value.trim();
            if (value === '') {
              isValid = false;
              field.classList.add('is-empty');

              if (!field.nextElementSibling || !field.nextElementSibling.classList.contains('invalid-feedback')) {
                const errorMessage = document.createElement('div');
                errorMessage.className = 'invalid-feedback';
                errorMessage.textContent = 'Campo obligatorio.';
                field.parentNode.insertBefore(errorMessage, field.nextSibling);
              } else {
                field.nextElementSibling.textContent = 'Campo obligatorio.';
              }
            } else {
              field.classList.remove('is-empty');
              if (field.nextElementSibling && field.nextElementSibling.classList.contains('invalid-feedback')) {
                field.nextElementSibling.remove();
              }
            }
          });
        });
      } else {
        console.log('Botón o formulario no encontrado.');
      }
    },
  };
})(jQuery, Drupal);
